import { sectorActions } from '../actions';

export default function sectors ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case sectorActions.SET_PROFILE_SECTORS: return generalSectorsReducer( newState, action );
        // case sectorActions.GENERAL_SECTORS_SUCCESS: return generalSectorsReducer( newState, action );
        default: return newState;
    }
}

function generalSectorsReducer ( newState, action ) {
    delete action.type;
    return  Object.assign( newState, { ...action } );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/sectors.js